/**
 * Catálogos del módulo de tareas.
 *
 * Los IDs corresponden a `control.TAB_STATUSES` en el backend.
 * Documentación: docs/modulos/04_TASKS_ENDPOINTS_GUIDE.md
 */

// ─── Status (grupo task_status) ─────────────────────────────────────
export const TASK_STATUSES = [
  { id: 26, key: "pending",     label: "Pending",     bg: "#FEF3C7", color: "#92400E" },
  { id: 27, key: "in_progress", label: "In Progress", bg: "#DBEAFE", color: "#1E40AF" },
  { id: 28, key: "completed",   label: "Completed",   bg: "#D1FAE5", color: "#065F46" },
  { id: 29, key: "cancelled",   label: "Cancelled",   bg: "#F3F4F6", color: "#6B7280" },
];

// ─── Priority (grupo task_priority) ─────────────────────────────────
export const TASK_PRIORITIES = [
  { id: 30, key: "high",   label: "High",   color: "#DC2626", bg: "#FEE2E2" },
  { id: 31, key: "medium", label: "Medium", color: "#D97706", bg: "#FEF3C7" },
  { id: 32, key: "low",    label: "Low",    color: "#16A34A", bg: "#E0E7FF" },
];

// ─── Category (grupo task_category) ─────────────────────────────────
export const TASK_CATEGORIES = [
  { id: 33, key: "follow_up",      label: "Follow-up Visit",  bg: "#FEE2E2", color: "#991B1B" },
  { id: 34, key: "care_gap",       label: "Care Gap Review",  bg: "#DBEAFE", color: "#1E40AF" },
  { id: 35, key: "coding_review",  label: "Coding Review",    bg: "#F3E8FF", color: "#6B21A8" },
  { id: 36, key: "outreach_call",  label: "Outreach Call",    bg: "#FEF3C7", color: "#92400E" },
  { id: 37, key: "lab_review",     label: "Lab Review",       bg: "#E0F2FE", color: "#075985" },
  { id: 38, key: "referral",       label: "Referral",         bg: "#FCE7F3", color: "#9D174D" },
  { id: 39, key: "documentation",  label: "Documentation",    bg: "#F1F5F9", color: "#475569" },
  { id: 40, key: "patient_recall", label: "Patient Recall",   bg: "#FFEDD5", color: "#9A3412" },
  { id: 41, key: "other",          label: "Other",            bg: "#F1F5F9", color: "#475569" },
];

// ─── Related types ──────────────────────────────────────────────────
export const RELATED_TYPES = [
  { key: "discharge",  label: "Discharge" },
  { key: "care_gap",   label: "Care Gap" },
  { key: "coding",     label: "Coding" },
  { key: "emergency",  label: "Emergency" },
  { key: "high_risk",  label: "High Risk" },
  { key: "recall",     label: "Recall" },
];

// ─── My role (devuelto por GET /tasks/my-tasks) ─────────────────────
export const MY_ROLES = [
  { key: "creator",  label: "Created by me",  color: "#F59E0B", bg: "#FFFBEB" },
  { key: "assignee", label: "Assigned to me", color: "#3B82F6", bg: "#EFF6FF" },
  { key: "both",     label: "Self-assigned",  color: "#8B5CF6", bg: "#F5F3FF" },
];

// ─── Helpers de lookup ──────────────────────────────────────────────
export const findStatus     = (key) => TASK_STATUSES.find((s) => s.key === key);
export const findPriority   = (key) => TASK_PRIORITIES.find((p) => p.key === key);
export const findCategory   = (key) => TASK_CATEGORIES.find((c) => c.key === key);
export const findMyRole     = (key) => MY_ROLES.find((r) => r.key === key);

export const statusIdFromKey   = (key) => findStatus(key)?.id ?? null;
export const priorityIdFromKey = (key) => findPriority(key)?.id ?? null;
export const categoryIdFromKey = (key) => findCategory(key)?.id ?? null;
